import { httpClient } from './http-client';

export interface AIInsight {
  /** info | watch | action */
  severity: string;
  title: string;
  detail: string;
}

export interface AIInsightsPayload {
  insights: AIInsight[];
  summary: string;
  analysis_type: string;
}

export interface AIInsightsResponse {
  insights: AIInsightsPayload | null;
  cached: boolean;
  generated_at?: string;
  model?: string;
  reason?: string;
  calls_today?: number;
  daily_limit?: number;
}

export interface AISettings {
  enabled: boolean;
  provider: string;
  model: string;
  has_own_key: boolean;
  key_hint?: string;
  calls_today: number;
  daily_limit: number;
}

/**
 * AI insights.
 *
 * `get` never costs anything — it reads the cache. Only `refresh` can call the
 * provider, and the server still declines if the figures have not changed.
 */
class AIService {
  static async getInsights(): Promise<AIInsightsResponse> {
    return httpClient.get<AIInsightsResponse>('/ai/insights');
  }

  static async refresh(): Promise<AIInsightsResponse> {
    return httpClient.post<AIInsightsResponse>('/ai/insights/refresh', {});
  }

  static async getSettings(): Promise<{ settings: AISettings; shared_key_available: boolean }> {
    return httpClient.get('/ai/settings');
  }

  static async saveSettings(input: {
    enabled: boolean; model?: string; api_key?: string;
  }): Promise<{ settings: AISettings; shared_key_available: boolean }> {
    return httpClient.put('/ai/settings', input);
  }
}

export const aiService = AIService;
